import customerDefaultValues from "./customerDefaultValues";
import _ from "lodash";
import Vue from "vue";
import moment from "moment";

export default {
  setEvent: function (state, eventId) {
    if (state.currentEventId === eventId) {
      return
    }

    this.commit('setCurrentEventId', eventId);

    state.promo = '';
    state.order = null;
    state.customers = [Object.assign({}, _.cloneDeep(customerDefaultValues))];
    state.eventPaid = false;

    this.commit('setMembersCount', 1);
    this.dispatch('getEvent');
  },

  setCurrentEventId: function (state, eventId) {
    state.currentEventId = eventId;
    localStorage.setItem('current_event_id', eventId);
  },

  setCurrentEvent: function (state, event) {
    state.currentEvent = event;
      this.commit('setPartialSum')
  },

  incMembersCount: function (state) {
    if (!state.currentEventId) {
      return
    }

    state.membersCount++;

    let isAvailable = false;
    let currentEventId = state.currentEventId;

    for(let event of state.events) {
      let eventStart = moment(event.date_start, 'DD.MM.YYYY').toDate();
      let currentStart = moment(state.currentEvent.date_start, 'DD.MM.YYYY').toDate();

      if (event.id !== state.currentEvent.id && eventStart >= currentStart && event.free_places >= state.membersCount) {
        isAvailable = true;
        currentEventId = event.id;
        break;
      }
    }

    if (state.membersCount > state.currentEvent.free_places) {
      if (isAvailable) {
        this.commit('setCurrentEventId', currentEventId);
      } else {
        state.membersCount--;
        return
      }
    }

    this.commit('saveMembersCount');
    this.dispatch('getEvent');
  },
  decMembersCount: function (state) {
    if (!state.currentEventId) {
      return
    }

    if (state.membersCount <= 1) {
      return
    }

    state.membersCount--;

    this.commit('saveMembersCount');
    this.dispatch('getEvent');
  },
  setMembersCount: function (state, value){
    if (value < 1) {
      return
    }

    state.membersCount = value;

    this.commit('saveMembersCount');
  },
  saveMembersCount: function (state){
    localStorage.setItem('members_count', state.membersCount);
  },
  addCustomer: function (state) {
    state.customers.push(_.cloneDeep(customerDefaultValues));
  },
  setInvoice: function (state, invoice) {
    state.invoice = invoice;
  },
  setOrder: function (state, order) {
    state.order = order;
  },
  setEvents: function (state, events) {
    state.events = events;

    this.commit('setDefaultEventId');
  },

  setDefaultEventId(state) {
    let isCurrentEventInDir = false;
    state.events.forEach(function (item) {
        if (!isCurrentEventInDir) {
            isCurrentEventInDir = (item.id == state.currentEventId);
        }
    });

    if (state.events.length && !isCurrentEventInDir) {
        let eventId = state.events[0].id;
        this.commit('setCurrentEventId', eventId);
        this.dispatch('getEvent');
    }
  },

  setDirections: function (state, directions) {
    state.directions = directions;
  },
  setCustomerId: function (state, customerId) {
    state.customerId = customerId;
  },
  setPromo: function (state, promo) {
    state.promo = promo;
  },
  setEventPaid: function (state) {
    state.eventPaid = true;

    state.membersCount = 1;
    state.promo = '';
    state.customers = [_.cloneDeep(customerDefaultValues)];

    this.dispatch('saveCustomers');
    this.commit('saveMembersCount', state.membersCount);
  },
  setCustomersLessThanMembers: function (state) {
    state.customers.splice(state.membersCount);
  },
  setEmptyBlank: function (state) {
    state.blank = {
      'self': true,
      'activity': '',
      'interests': '',
      'experience': '',
      'wherefrom': '',
      'other': '',
      'sex': ''
    };

    state.blankSaved = true;
  },
  setCurrentRouteName: function (state, name) {
    state.currentRouteName = name;
  },
  setAvailablePlacesCount: function (state, count) {
    state.availablePlacesCount = count;
  },
  setIsOverdueTime: function (state, value) {
    state.isOverdueTime = value;
  },
  setCart: function (state, cart) {
    state.cart = cart.cart;
    state.currentEventId = cart.cart.event;
    state.membersCount = cart.cart.membersCount || state.DEFAULT_MEMBERS_COUNT;
  },
  setIsLoader: function (state, value) {
    state.isLoader = value;
  },
  setOrderAddressError: function (state, value) {
    state.orderAddressError = value;
  },
  validateCustomerPhone: function (state, { itiNumber, isValid }) {
    for(let id in state.customers) {
       let customer = state.customers[id];
       if (customer.phone.value === itiNumber) {
        Vue.set(state.customers[id].phone, 'isValid', isValid);
       }
    }
  },
  setCustomerPhone: function (state, {customerIndex, itiNumber}) {
      Vue.set(state.customers[customerIndex].phone, 'value', itiNumber);
  },

  setPartial: function (state, value) {
      if (value === 0) {
          this.commit('setEmptyPartial');
          return;
      }

      state.partialPay.percent = value;
      this.commit('setPartialSum');
  },

  setPartialSum: function (state) {
      if (typeof state !== "undefined" && state.partialPay.percent) {
          this.commit('setPartialSumPercent', state.partialPay.percent);
      }
  },

  setPartialSumPercent: function(state, percent) {
    if (state.currentEvent) {
      let sum = 0;

      if (state.currentEvent.discount || state.currentEvent.discountMembersCount || state.currentEvent.discountPromo) {
        sum = state.currentEvent.discountPrice;
      } else {
        if (state.order) {
          sum = state.order.sum;
        } else {
          sum = state.currentEvent.price;
        }
      }

      let percentSum = (sum * percent) / 100;

      this.commit('setPartialPaymentSum', Math.round(percentSum));
    }
  },
  setPartialSumValue: function(state, value) {
    let eventSum = 0;
    let val = parseInt(value);

    if (!val) {
      val = 0;
    }

    if (state.currentEvent) {
      if (state.currentEvent.discount || state.currentEvent.discountMembersCount || state.currentEvent.discountPromo) {
        eventSum = state.currentEvent.discountPrice;
      } else {
        if (state.order) {
          eventSum = state.order.sum;
        } else {
          eventSum = state.currentEvent.price;
        }
      }
    }

    if (typeof eventSum != 'number') {
      eventSum = parseInt(eventSum);
    }

    if (value > eventSum) {
      return;
    }

    state.partialPay.sum = value;
  },
  setPartialPaymentSum: function(state, sum) {
    state.partialPay.sum = sum;
  },
  setEmptyPartial: function (state) {
    state.partialPay.percent = 0;
    state.partialPay.sum = 0;
  }
}
